"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sandwich = exports.SandwichProvider = void 0;
var react_1 = __importStar(require("react"));
var SandwichContext = (0, react_1.createContext)(null);
var SANDWICH_CONTEXT_ERROR = "useSandwich couldn't access the SandwichContext object.\n\n  This might be due to\n    - useSandwich was used outside a parent SandwichProvider\n    - there are multiple versions of ui-tools installed and SandwichProvider was imported from a different one\n";
function DefaultComponent(_a) {
    var children = _a.children;
    return children;
}
function useSandwich(id) {
    var sandwiches = (0, react_1.useContext)(SandwichContext);
    if (sandwiches === null) {
        throw new Error(SANDWICH_CONTEXT_ERROR);
    }
    // Do not inline the DefaultComponent implementation. The reference needs to remain constant
    // otherwise we can get into unintended re-rendering loops.
    var _a = sandwiches, _b = id, _c = _a[_b], sandwich = _c === void 0 ? DefaultComponent : _c;
    return sandwich;
}
function Sandwich(_a) {
    var id = _a.id, children = _a.children, props = _a.props;
    var Component = useSandwich(id);
    return react_1.default.createElement(Component, __assign({}, props), children);
}
exports.Sandwich = Sandwich;
var SandwichProvider = function (_a) {
    var children = _a.children, _b = _a.modify, modify = _b === void 0 ? {} : _b;
    return (react_1.default.createElement(SandwichContext.Provider, { value: modify }, children));
};
exports.SandwichProvider = SandwichProvider;
